module.exports = __webpack_public_path__ + "assets/215fa74d739faf531d904d332435cafb.png";